export function restoreFinding(api, clientId, findingId) {
  return api.post(`/clients/${clientId}/findings/${findingId}/restore`);
}

export function restoreFindingErrorMessage(error) {
  const status = error?.status || error?.response?.status;
  if (status === 409) {
    return 'This finding is not currently suppressed. Refresh the page and try again.';
  }
  if (status === 404) {
    return 'This finding could not be found. It may have been removed or restored elsewhere.';
  }
  return error?.message || 'Unable to restore this finding. Try again.';
}
